module.exports = __webpack_public_path__ + "static/media/11.a1476dd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/11.jpg
// module id = 701
// module chunks = 0